import { render, staticRenderFns } from "./VistaPostEmision.vue?vue&type=template&id=78ce1885&"
import script from "./VistaPostEmision.vue?vue&type=script&lang=js&"
export * from "./VistaPostEmision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports